import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import QuizService from '../../services/QuizService';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import SettingService from '../../services/SettingService';
import Constants from '../../utils/constants';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import ResultDialog from './ResultDialog';
import { Button, Menu } from 'primereact';
class QuizListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new QuizService());
        this.settingService = new SettingService();
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            emailTypeOptions: [],
            resultDialog: false
        };
        this.displayResultDialog = this.displayResultDialog.bind(this);
        this.handleCloseResultDialog=this.handleCloseResultDialog.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            hideExpired: criteria.hideExpired,
            locale: criteria.locale,
            text: criteria.text,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            hideExpired: false,
            text: '',
            locale: this.authService.getI18n(),
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'quiz.listTitle';
    }
    getCriteriaName() {
        return 'quiz-list-sc';
    }

    getContainerListName() {
        return 'quiz-list-container';
    }

    renderCriteria() {
        return (
            <CriteriaCheckboxComponent
                id='hideExpired'
                name='hideExpired'
                label={t('quiz.hideExpired')}
                value={this.state.criteria.hideExpired}
                onChange={this.handleChangeSc}
                validator={this.validator}
            />
        );
    }
    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('global.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {
                field: 'id',
                header: t('quiz.id'),
                sortable: true,
            },
            {
                field: 'type.label',
                header: t('quiz.type'),
                sortField: 'type',
                sortable: true,
            },
            {
                field: 'title',
                header: t('quiz.title'),
                sortable: true,
            },
            {
                field: 'status.label',
                header: t('welcome-survey.list.status'),
                sortField: 'status',
                sortable: true,
            },
            {
                field: 'activeFrom',
                header: t('welcome-survey.list.activeFrom'),
                body: this.dateTemplate.bind(this, 'activeFrom', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                field: 'activeTo',
                header: t('welcome-survey.list.activeTo'),
                body: this.dateTemplate.bind(this, 'activeTo', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }


    translate(key) {
        const {t} = this.props;
        return t(key);
    }


    displayResultDialog(data){
            this.setState({
                resultDialog: true,
                quizId: data.id
            })
    }
    handleCloseResultDialog(){
        this.setState({
            resultDialog: false,
            quizId: undefined
        })
    }


    actionTemplate(rowData) {
        const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            },
            rowData.status.enumValue === 'COMPLETED' && {
                label: t('global.results'),
                icon: 'pi pi-chart-line',
                command: () => this.displayResultDialog(rowData),
            }
        ].filter(Boolean); // Usuwa `false` wartości, jeśli warunek nie jest spełniony
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }
    //override
    actionTemplate2(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
                <span></span>
                
                <ActionLink
                    rendered={rowData.status.enumValue=='COMPLETED'}
                    className='p-link float-right'
                    handleClick={(e)=>this.displayResultDialog(rowData)}
                    variant='blue'
                    iconName='mdi-chart-timeline-variant'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'                    
                />
            </div>
            
        );
    }

    breadCrumbItems() {
        return [{name: t('quiz.listTitle'), url: '/quiz-list'}];
    }
    render() {
        return (
            <div className='container-fluid'>
                {this.state.resultDialog ?
                    <ResultDialog
                        style={{ maxWidth: '800px', height:'fit-content' }}
                        roleOptions={this.state.role}
                        elementId={this.state.elementId}
                        onHide={this.handleCloseResultDialog}
                        visible={this.state.resultDialog}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                        quizId={this.state.quizId}
                        locale={this.authService.getI18n()}
                    /> : null
                }
                {this.renderView()}
            </div>
        )
    }
}

QuizListContainer.defaultProps = {
    detailUrl: '/quiz/details',
    newUrl: '/quiz/create',
    editUrl: '/quiz/edit',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

QuizListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(QuizListContainer));
